import { getEnvironment as n, domainIncludesTenantClient as o } from "./utils.js";
const a = "https://public.propify.com", E = "https://tenant-client-stage.dev.propify.com";
let i = {
  ACCOUNTS_URL: "/accounts",
  AMENITY_TYPES_URL: "/amenity-types",
  APPLICATION: "/applications",
  BASE_URL: "",
  BRAND: "/brands",
  CHARGES: "/charges",
  ENUMERATION_URL: "/enumerations",
  FILES: "/files",
  FORM_URL: "/forms",
  IDENTITY_URL: "/identities",
  LEAD_QUALIFICATION_FORM_URL: "/lead-qualification-form",
  LEADS_URL: "/leads",
  LEASE: "/leases",
  OAUTH_URL: "/auth",
  OFFICE_URL: "/offices",
  PAYMENT: "/payments",
  PAYMENT_METHODS_URL: "/payment-methods",
  PAYMENT_SETTINGS: "/payment-settings",
  PLACES_URL: "/places",
  PROMOTIONS: "/promotions",
  PUBLIC_ACCOUNT_AGREEMENTS: "/public-account-agreements",
  RENEWALS: "/renewals",
  SERVICE_QUESTIONS: "/service-questions",
  SERVICES: "/services",
  SHOWINGS_URL: "/showings",
  SMART_HOME_SYSTEMS_URL: "/smart-home/systems",
  SYSTEM_URL: "/sys",
  UI_OPTIONS_URL: "/ui-options",
  UNIT_APPLICATION: "/unit-applications",
  UNIT_SYSTEM_MANAGER_URL: "/unit-system-managers",
  UNITS_URL: "/units",
  WAITING_LIST_URL: "/units/waiting-list",
  WORK_ORDERS: "/work-orders"
};
const R = () => {
  switch (n()) {
    case "production":
      return a;
    case "stage":
      return o() ? window.location.origin : E;
    default:
      return "";
  }
}, U = () => {
  const e = R();
  if (e) {
    const t = { ...i };
    t.BASE_URL = e, Object.keys(t).map((s) => s).forEach((s) => {
      t[s] && !t[s].includes("http") && (t[s] = `${e}/rest${t[s]}`);
    }), i = t;
  }
};
export {
  i as api,
  R as getApiBaseUrl,
  U as initializeApi
};
//# sourceMappingURL=configuration.js.map
